import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { BaseChartService } from '../services';
import { BarChartDate } from '../models';

@Injectable({
  providedIn: 'root',
})
export class MockChartService extends BaseChartService<any> {
  constructor() {
    super('', undefined);
  }

  get(model: BarChartDate): Observable<any[]> {
    return of([]);
  }
}
